// System
import { Button, Stack, Typography } from '@mui/material';

// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useProviderDrawer } from '@Modal/hooks/providers/useProviderDrawer';
import { useConfigsTable } from '@Modal/hooks/providers/useConfigsTable';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useDispatch } from 'react-redux';
import { ChangeEvent, useRef } from 'react';
import { useCreateProviderConfig } from '@Modal/hooks/providers/useCreateProviderConfig';
import { useGetProviderConfigsQuery } from '@Src/generated.graphql';

export const ConfigsTitle: React.FC = () => {
  const { selectedProviderData, uploadCurrencies, handleExportCurrencyConfigs } =
    useProviderDrawer();
  const dispatch = useDispatch();
  const { configTableFilters, clearConfigTableFiltersHandler } = useConfigsTable();
  const { setShowCreateProviderConfigForm } = useCreateProviderConfig();
  const { userPermissions, currentUser } = useAuthorization();
  const { data, loading } = useGetProviderConfigsQuery({
    variables: { id: selectedProviderData?.id, filter: configTableFilters },
  });

  const canManageProviderConfigs =
    userPermissions?.includes('CAN_MANAGE_PROVIDER_CONFIGS') || currentUser.isSuper;

  const objectVals = Object.values(configTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e?.target?.files?.[0];
    if (file) {
      uploadCurrencies(file);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <AtLocator type="container" name="customerListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="flex-start" gap="10px">
          <Typography variant="h3">{selectedProviderData?.name}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          {canManageProviderConfigs && (
            <>
              {/* <Button
                variant="outlined"
                onClick={handleExportCurrencyConfigs}
                disabled={data?.providerConfigs?.length === 0}
              >
                Export Currencies
              </Button> */}
              {/* <Button variant="outlined" onClick={() => fileInputRef.current?.click()}>
                Import file
              </Button> */}
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
              <Stack gap={1}>
                <Button
                  variant="outlined"
                  onClick={() => dispatch(setShowCreateProviderConfigForm(true))}
                  sx={{ width: '200px' }}
                >
                  Add Currency
                </Button>
              </Stack>
            </>
          )}
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={clearConfigTableFiltersHandler}
            sx={{ height: '34px' }}
          >
            Clear filters
          </Button>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
